// H5端 审计table card
import './index.less';

import { Button, Card } from 'antd';
import { FC } from 'react';

import { useI18nContext } from '@/i18n/I18n';

interface IAuditProps {
  auditId: string;
  auditDate: string;
  auditType: string;
  toggleReserveModal: (auditId: string) => void;
}

const AuditCard: FC<IAuditProps> = ({
  auditId,
  auditType,
  auditDate,
  toggleReserveModal,
}) => {
  const [$t] = useI18nContext();
  const renderType = (auditType: string | number) => {
    let type: any = '';
    if (auditType == '1') {
      type = $t('reserveProof');
    } else {
      type = auditType;
    }
    return <span className="td-auditType">{type}</span>;
  };
  return (
    <Card className="auditCard" bordered={false}>
      <div className="auditId">
        <div>{$t('auditNumber')}</div>
        <div>{auditId}</div>
      </div>

      <div className="auditRow">
        <div>{$t('Date')}</div>
        <div>{auditDate}</div>
      </div>
      <div className="auditRow">
        <div>{$t('auditType')}</div>
        <div>{renderType(auditType)}</div>
      </div>
      <Button
        type="link"
        onClick={() => toggleReserveModal(auditId)}
        style={{ height: 24 }}
      >
        {$t('child.details')}
      </Button>
    </Card>
  );
};

export default AuditCard;
